import { Component, h, VNode } from 'preact';
import { classNames } from '../../style';
import { Properties } from '../types';

const tx = classNames();

export interface LayoutProps extends Properties {
  hCenter?: boolean;
  vCenter?: boolean;
  grow?: boolean;
  fill?: boolean;
  wrapMe?: boolean;
}

export class Column extends Component<LayoutProps, never> {
  static defaultProps: LayoutProps = {
    hCenter: false,
    vCenter: true,
    grow: true,
    fill: true,
    wrapMe: false,
  };

  render({ hCenter, vCenter, grow, fill, wrapMe, children, ...attr }: LayoutProps): VNode {
    return (
      <div
        {...attr}
        class={tx(this.props.class, 'flex flex--column', {
          'flex--middle': hCenter,
          'flex--left-center': vCenter,
          grow,
          fill,
          'flex--wrap': wrapMe,
        })}
      >
        {children}
      </div>
    );
  }
}

export class Row extends Component<LayoutProps, never> {
  static defaultProps: LayoutProps = {
    hCenter: false,
    vCenter: true,
    grow: true,
    fill: true,
    wrapMe: false,
  };

  render({ hCenter, vCenter, grow, fill, wrapMe, children, ...attr }: LayoutProps): VNode {
    return (
      <div
        {...attr}
        class={tx(this.props.class, 'flex', {
          'flex--left-center': hCenter,
          'flex--middle': vCenter,
          grow,
          fill,
          'flex--wrap': wrapMe,
        })}
      >
        {children}
      </div>
    );
  }
}
